'use client'

import { keepPreviousData, useQuery } from '@tanstack/react-query'

import { getBatchOrderPreview } from '@/service/order-preview-batch.api'
import { BatchOrderPreviewRequest } from '@/types/generated/public_api'

export function useBatchOrderPreview(request: BatchOrderPreviewRequest | null) {
  return useQuery({
    queryKey: ['order-preview-batch', request],
    queryFn: () => getBatchOrderPreview(request!),
    enabled: request !== null,
    placeholderData: keepPreviousData,
  })
}
